type ChatInputAreaProps = {
  children: React.ReactNode;
  dataLoc?: string;
};

export const ChatInputArea: React.FC<ChatInputAreaProps> = ({
  children,
  dataLoc,
}) => (
  <div className="px-2 py-4" data-loc={dataLoc}>
    {children}
  </div>
);
